

<template>
  <!-- Pizza Slider Start -->
  <section class="pizza_slider_area">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="site_heading">
            <h3 class="sub_title">Fresh Quality</h3>
            <h2 class="section_title">We Offer People Best Way<br> To Eat Best Food</h2>
            <img alt="img" class="section_devider" src="../assets/img/section_delimiter.png">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-11 mx-auto">
          <div class="row">
            <div class="col-md-12">
              <div class="pizza_slide owl-carousel">
                <div class="pizza_item" v-for="(product, key) in products" :key="key">
                  <div class="pizza_slide_img">
                    <img alt="img" v-bind:src="require(`@/assets/img/${product.img}`)"/>
                    <div class="pizza_slide_action">
                      <a href="javascript:;" @click.stop.prevent="addToCart(product)"><i class="fas fa-shopping-cart"></i> Add to cart</a>
                    </div>
                  </div>
                  <div class="pizza_slide_text">
                    <h3><a href="javascript:;">{{product.title}}</a></h3>
                    <p>{{product.excerpt}}</p>
                    <h3 class="pizza_slide_price"><span class="currencySymbol">£</span>{{product.price}}</h3>
                  </div>
                </div>
              </div>
              <div class="pizza_nav">
                           <span class="prev_slide">
                              <svg height="45" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="0 0 64.000000 64.000000"
                                   width="45" xmlns="http://www.w3.org/2000/svg">
                                 <g fill="#000000" stroke="none"
                                    transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)">
                                    <path
                                      d="M326 523 c-97 -48 -176 -93 -176 -100 0 -17 2 -16 46 5 27 12 38 14 41 5 26 -77 142 -95 188 -29 18 25 20 97 3 114 -9 9 -9 15 -1 23 17 17 43 3 43 -24 0 -13 7 -32 15 -43 8 -10 15 -35 15 -55 0 -20 3 -39 6 -42 4 -3 7 -29 7 -57 0 -28 -3 -54 -7 -57 -3 -3 -6 -22 -6 -42 0 -20 -7 -45 -15 -55 -8 -11 -15 -30 -15 -43 0 -13 -6 -26 -14 -29 -8 -3 -55 15 -104 40 l-91 46 11 30 c19 57 -25 120 -85 120 -61 0 -97 -46 -97 -125 0 -25 -4 -45 -10 -45 -5 0 -10 25 -10 55 0 44 -4 57 -20 67 -27 17 -27 64 0 73 22 7 26 20 10 30 -14 9 -60 -40 -60 -63 0 -11 9 -30 19 -44 12 -15 21 -44 23 -73 2 -32 9 -52 21 -59 25 -16 51 4 55 42 l3 31 194 -96 c175 -87 197 -95 220 -85 27 13 65 67 65 95 0 30 -15 19 -38 -28 -16 -34 -27 -45 -44 -45 -33 0 -55 15 -34 23 10 4 16 18 16 36 0 16 7 36 15 44 9 10 13 26 9 44 -3 17 1 36 9 48 11 14 12 25 4 42 -7 16 -7 30 0 46 8 17 7 28 -4 42 -8 12 -12 31 -9 48 4 18 0 34 -9 44 -8 8 -15 28 -15 44 0 18 -6 32 -16 36 -21 8 1 23 34 23 19 0 29 -13 55 -67 27 -58 32 -82 35 -163 2 -52 5 -102 8 -110 10 -29 24 13 24 72 0 142 -66 298 -126 298 -6 0 -91 -39 -188 -87z m84 -22 c26 -50 -13 -114 -68 -114 -33 0 -82 35 -82 60 0 12 103 72 127 73 7 0 17 -9 23 -19z m-186 -212 c25 -20 33 -50 20 -83 -5 -13 -15 -11 -65 14 -32 17 -59 34 -59 39 0 13 49 51 65 51 7 0 24 -9 39 -21z"/>
                                    <path
                                      d="M360 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M310 441 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"/>
                                    <path
                                      d="M180 270 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"/>
                                    <path
                                      d="M100 400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M190 380 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0 -16 -4 -16 -10z"/>
                                    <path
                                      d="M450 350 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M342 288 c-15 -15 -15 -51 0 -66 27 -27 98 -2 98 35 0 33 -73 56 -98 31z m66 -31 c4 -22 -24 -33 -43 -17 -12 10 -13 16 -4 27 16 18 43 13 47 -10z"/>
                                    <path
                                      d="M600 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M410 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0-10 -4 -10 -10z"/>
                                 </g>
                              </svg>
                           </span>
                <span class="next_slide">
                              <svg height="45" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="0 0 64.000000 64.000000"
                                   width="45" xmlns="http://www.w3.org/2000/svg">
                                 <g fill="#000000" stroke="none"
                                    transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)">
                                    <path d="M91 594 c-46 -33 -91 -172 -91 -282 0 -59 14 -101 24 -72 3 8 6 58 8 110 3 81 8 105 35 163 26 54 36 67 55 67 33 0 55 -15 34 -23 -10 -4 -16 -18 -16 -36 0 -16 -7 -36 -15 -44 -9 -10 -13 -26 -9 -44 3 -17 -1 -36 -9 -48 -11 -14 -12 -25 -4 -42 7 -16 7 -30 0 -46 -8 -17 -7 -28 4 -42 8 -12 12 -31 9 -48 -4 -18 0 -34 9 -44 8 -8 15 -28 15 -44 0 -18 6 -32 16 -36 21 -8 -1 -23 -34 -23 -17 0 -28 11 -44 45 -23 47 -38 58 -38 28 0 -28 38 -82 65 -95 23 -10 45 -2 220 85 l194 96 3 -31 c4 -38 30 -58 56 -42 11 7 18 27 20 59 2 29 11 58 23 73 10 14 19 33 19 44 0 23 -46 72 -60 63 -16 -10 -12 -23 10 -30 27 -9 27 -56 0 -73 -16 -10 -20 -23 -20 -67 0 -30 -4 -55 -10 -55 -5 0 -10 20 -10 45 0 79 -36 125 -97 125 -60 0 -104 -63 -85 -120 l11 -30 -91 -46 c-49 -25 -96 -43
                                       -104 -40 -8 3 -14 16 -14 29 0 13 -7 32 -15 43 -8 10 -15 35 -15 55 0 20 -3 39 -6 42 -4 3 -7 29 -7 57 0 28 3 54 7 57 3 3 6 22 6 42 0 20 7 45 15 55 8 11 15 30 15 43 0 27 26 41 43 24 8 -8 8 -14 -1 -23 -17 -17 -15 -89 3 -114 46 -66 162 -48 188 29 3 9 14 7 41 -5 44 -21 46 -22 46 -5 0 12 -343 188 -365 187 -6 0 -21 -7 -34 -16z m229 -104 c33 -17 60 -36 60 -43 0 -8 -11 -24 -25 -37 -64 -60 -166 13 -125 91 14 25 20 24 90 -11z m174 -201 c14 -11 26 -25 26 -30 0 -5 -27 -22 -59 -39 -63 -32 -71 -29 -71 25 0 24 41 65 65 65 7 0 24 -9 39 -21z"/>
                                    <path
                                      d="M260 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M310 434 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"/>
                                    <path
                                      d="M430 270 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"/>
                                    <path
                                      d="M520 400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M425 380 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0 -12 -4 -9 -10z"/>
                                    <path
                                      d="M170 350 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M217 282 c-22 -24 -21 -35 1 -55 22 -20 63 -22 80 -5 15 15 15 51 0 66 -18 18 -63 14 -81 -6z m62 -16 c9 -10 8 -16 -4 -26 -17 -14 -45 -7 -45 13 0 29 30 37 49 13z"/>
                                    <path
                                      d="M20 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                    <path
                                      d="M210 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"/>
                                 </g>
                              </svg>
                           </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Pizza Slider End -->
</template>
<script>
import {mapState} from 'vuex';

export default {
  name: 'PizzaSliderArea',
  mounted() {
    $(".pizza_slide").owlCarousel({
      autoplay: true,
      loop: true,
      margin: 30,
      touchDrag: true,
      mouseDrag: true,
      nav: false,
      dots: false,
      autoplayTimeout: 6000,
      autoplaySpeed: 1200,
      responsive: {
        0: {
          items: 1
        },
        480: {
          items: 1
        },
        600: {
          items: 2
        },
        1000: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });

    var selector = $('.pizza_slide');

    $('.next_slide').click(function () {
      selector.trigger('next.owl.carousel');
    });

    $('.prev_slide').click(function () {
      selector.trigger('prev.owl.carousel');
    });
  },
  computed: {
    ...mapState({
      products: state => state.products.items
    })
  },
  methods: {
    addToCart(product) {
      //add to cart
      let {sku, cat, title, price, img} = product;

      this.$store.dispatch('addToCart', {sku, cat, title, price, img, total: price, quantity: 1})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PizzaSliderArea.vue